"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpanLinkChooserState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
const services_1 = require("../../services");
const store_1 = require("../../store");
const multi_list_chooser_state_1 = require("./multi.list.chooser.state");
class SpanLinkChooserState extends multi_list_chooser_state_1.MultiChooserState {
    constructor(collection) {
        super((0, i18n_1.Translate)(i18n_1.T.SPAN));
        this.collection = collection;
    }
    get groups() {
        const spanLinkRecords = this.nearbySpans;
        if (spanLinkRecords == null) {
            return null;
        }
        if (spanLinkRecords.length === 0) {
            this.setError(i18n_1.T.SPAN_LINK_NO_MATCH);
            return [];
        }
        this.setError(null);
        const items = [];
        for (const spanLinkRecord of spanLinkRecords) {
            const collection = spanLinkRecord.collection;
            const spanInstance = spanLinkRecord.instance;
            const collectionTitle = this.getCollectionTitle(collection);
            items.push({
                key: collection.id,
                value: `${collection.schema.titleField.displayName} = ${collectionTitle}, ${spanInstance.title}`,
            });
        }
        return [
            {
                title: (0, i18n_1.Translate)(i18n_1.T.SPAN_LINK_SELECT_CONTENT),
                items,
                selected: items.length > 0 ? items[0].key : null,
            },
        ];
    }
    selectDefaultValue() {
        const spanLinkRecords = this.nearbySpans;
        if (spanLinkRecords == null || spanLinkRecords.length === 0) {
            this.setValue(null);
        }
        else {
            this.setValue([spanLinkRecords[0].collection.id]);
        }
    }
    get nearbySpans() {
        const tagSummary = store_1.AppStore.TagSummary.get(this.collection.jobId);
        if (tagSummary == null || tagSummary.revisions == null) {
            return null;
        }
        const collections = [];
        for (const collectionRevision of tagSummary.revisions) {
            const collection = store_1.AppStore.Collection.get(collectionRevision);
            if (collection != null) {
                collections.push(collection);
            }
        }
        if (collections.length === 0) {
            return null;
        }
        const candidateCollections = collections.filter((collection) => collection.id !== this.collection.id);
        return services_1.Services.SubFormLink.findLinks(this.collection, candidateCollections);
    }
    setValue(value) {
        this._value = value;
    }
    getSelectedSpanLinkRecord() {
        if (this.value == null) {
            return null;
        }
        return this.nearbySpans.find((record) => record.collection.id === this.value[0]);
    }
    getCollectionTitle(collection) {
        const title = collection.title;
        return title != null ? title : (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE);
    }
}
exports.SpanLinkChooserState = SpanLinkChooserState;
tslib_1.__decorate([
    mobx_1.action
], SpanLinkChooserState.prototype, "selectDefaultValue", null);
tslib_1.__decorate([
    mobx_1.computed
], SpanLinkChooserState.prototype, "nearbySpans", null);
tslib_1.__decorate([
    mobx_1.action
], SpanLinkChooserState.prototype, "setValue", null);
//# sourceMappingURL=span.link.chooser.state.js.map